import { isInternalTeam } from './internalAccounts';

export const FEATURE_KEYS = {
  interest_test: 'interest_test',
  ability_test: 'ability_test'
};

export const FEATURE_REGISTRY = {
  interest_test: { key: 'interest_test', path: '/interest-test', labelKey: 'navigation.interestTest' },
  ability_test: { key: 'ability_test', path: '/ability-test', labelKey: 'navigation.takeTest' }
};

/** Available to every signed-in user without a feature invite. */
export const STANDARD_FEATURES = [FEATURE_KEYS.interest_test, FEATURE_KEYS.ability_test];

/** Resolve a grantable feature key to a locale-aware label. */
export function featureLabel(t, key) {
  const labelKey = FEATURE_REGISTRY[key]?.labelKey;
  return labelKey ? t(labelKey) : key;
}

function grantIsActive(grant) {
  if (!grant || grant.revoked_at) return false;
  if (grant.expires_at && new Date(grant.expires_at).getTime() < Date.now()) return false;
  return Boolean(FEATURE_REGISTRY[grant.feature]);
}

export function getActiveFeatures(user) {
  if (!user) return [];
  if (isInternalTeam(user)) return Object.keys(FEATURE_REGISTRY);
  const fromGrants = (user.feature_access || []).filter(grantIsActive).map((g) => g.feature);
  return [...new Set([...fromGrants, ...STANDARD_FEATURES])];
}

export function hasFeature(user, feature) {
  if (!user) return false;
  if (STANDARD_FEATURES.includes(feature)) return true;
  return getActiveFeatures(user).includes(feature);
}

export function isFeatureTrialUser(user) {
  if (!user || isInternalTeam(user)) return false;
  return user.access_mode === 'feature_trial' && getActiveFeatures(user).length > 0;
}

export function defaultFeaturePath(user) {
  const features = getActiveFeatures(user);
  const match = features.map((key) => FEATURE_REGISTRY[key]?.path).find(Boolean);
  return match || '/interest-test';
}
